import './Especialidades.css';
import { especialidadesData, WHATSAPP_URL } from '../../constants';

function Especialidades() {

  return (
    <section id="especialidades" className="especialidades-section">
      <div className="especialidades-container">
        <h2>Especialidades</h2>
        <div className="especialidades-grid">
          {especialidadesData.map((esp, index) => (
            <div key={index} className={`especialidade-card ${esp.color}`}>
              <div className="especialidade-icon">
                {esp.icon ? (
                  <img src={esp.icon} alt={esp.title} className="icon-image" />
                ) : (
                  <div className="icon-circle"></div>
                )}
              </div>
              <h3>{esp.title}</h3>
              <p>{esp.description}</p>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="agendar-btn">Agendar</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Especialidades;
